import React, { Component } from 'react'
import './TermsAndConditions.scss'

export default class TermsAndConditions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      privacyPolicyLink: 'https://www.opcity.com/privacy-policy/'
    }
  }

  render() {
    return (
      <div className="TermsAndConditions">
        <div className="TermsAndConditions__header">
          <h1>NETWORK TERMS AND CONDITIONS</h1>
          <h3>Real Estate Agents</h3>
        </div>
        <div className="TermsAndConditions__frame">
          <div className="TermsAndConditions__last-updated">
            Last Updated: January 21, 2025
          </div>
          <div>

            <p>
              By using or accessing realtor.com, the Referral platform, or any mobile application for such
              products or portals (each referred to herein as the &quot;<strong>Product</strong>&quot;), you acknowledge and agree that
              you are subject to the following terms and conditions, as well as our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer">Privacy Policy</a>,
              which also governs your use of the Product, and is incorporated by reference (These Terms and
              Conditions with the Privacy Policy along with your  Participation Agreement and any Referral
              Agreements shall be referred to as the &quot;<strong>Terms</strong>&quot;). Please read these Terms carefully, as they
              contain important information about limitations of liability and resolution of disputes
              through arbitration rather than court.
            </p>

            <p>
              If you do not fully agree to these Terms and any other terms and conditions posted or linked
              to any Product, you are not authorized to access or otherwise use the Product. Under these Terms,
              "use" or "access" of the Product specifically includes any direct or indirect access or use of
              the Product or any cached version of the Product. The Product is operated by Move Sales, Inc.
              Unless otherwise specified, the entity controlling the Product you are accessing is referred to
              herein as &quot;<strong>Move Sales, Inc.,</strong>&quot; &quot;<strong>MSI,</strong>&quot; &quot;<strong>realtor.com,</strong>&quot; &quot;<strong>we,</strong>&quot; &quot;<strong>us</strong>&quot; or &quot;<strong>our</strong>&quot;. We may refer to you,
              the real estate agent, as &quot;<strong>you</strong>&quot; or a &quot;<strong>user</strong>&quot; of the Product.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">1.</span>The Product is a Service and We are Not a Party to any Transaction Between Users of
              the Product and/or MSI Service.</b></p>

            <p>
              We are not a party to any rental, purchase or other agreement between you and consumers. This is true even
              if the Product allows you to interact with consumers, set appointment times, and track transaction
              progress. As a result, any part of an actual or potential transaction between a you and a consumer,
              including the quality, condition, safety or legality of the properties advertised, the truth or accuracy
              of the listings (including the content thereof or any review relating to any traveler or property),
              are solely the responsibility of each user.
            </p>

            <p>
              You agree to be responsible for, and agree to abide by, all laws, rules and regulations applicable
              to the services you provide and your use of the service or Product offered. You further agree
              that you are responsible for and agree to abide by all laws, rules, ordinances, or regulations
              applicable to conduct of your real estate business, including but not limited to any and all laws,
              rules, ordinances, regulations or other requirements relating to taxes, credit cards, data and
              privacy, permits or license requirements, zoning ordinances, safety compliance and compliance
              with all anti-discrimination and fair housing laws, as applicable. Please be aware that, even
              though we are not a party to any transaction, there may be circumstances where we are nevertheless
              legally obligated (as we may determine in our sole discretion) to provide information related
              to your services in order to comply with requests from governmental bodies in relation to
              investigations, litigation or administrative proceedings, and we may choose to comply with such
              obligations in our sole discretion. You agree to provide disclosures (in the form we provide)
              to any third party upon our request.  You are also responsible for any associated sales taxes
              related to your participation with this Product and receipt of referrals.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">2.</span>Limited License to Use the Product.</b></p>

            <p>
              Users are granted a limited, revocable non-exclusive license to access the Product and the content and
              services provided on the Product solely for the purpose of accepting leads, tracking leads, communicating
              with MSI and/or leads, and other related services as permitted by MSI and in accordance with the
              Terms.  Any use of the Product that is not for one of these purposes or otherwise in accordance with
              the Terms or as otherwise authorized by us in writing is expressly prohibited.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">3.</span>Unauthorized Uses of the Product.</b></p>

            <p>The license to use the Product only extends to the uses expressly described herein. The license to
              use the Product granted to users in these Terms does not include any right of collection,
              aggregation, copying, scraping, duplication, display or any derivative use of the Product nor any
              right of use of data mining, robots, spiders or similar data gathering and extraction tools without
              our prior written permission.</p>

            <p><b><span className="TermsAndConditions__ordered-list">4.</span>Proprietary Rights and Downloading of Information from the Product.</b></p>

            <p>The Product and all content and information on the Product are protected by copyright as a collective
              work and/or compilation, under applicable U.S. and international copyright laws and conventions and
              database rights.  You agree to abide by any and all copyright notices, information or restrictions
              contained in or relating to any content on the Product. Copying, storing or otherwise accessing the
              Product or any content on the Product other than for your personal, noncommercial use (other than in
              accordance with a valid listing) is expressly prohibited without prior written permission from us. As
              part of tracking a real estate transaction, you may download, display and/or print one copy of any portion
              of the Product. You may not modify the same, and you must reproduce our copyright notice in the form
              displayed on the relevant portion(s) of the Product that you desire to download, display or print.</p>

            <p><b><span className="TermsAndConditions__ordered-list">5.</span>Your E-mail Address, Phone Number and Data; Our Privacy Policy; Data Transmittal.</b></p>

            <p>
              When you provide your e-mail address, phone number, name or other information to us in connection with
              your use or access to the Product, any service or tool provided in the Product or otherwise, you agree
              to allow the MSI to add your e-mail address, phone number, name or other information provided to our
              database of users. You may receive one or more promotional e-mails from either MSI or MSI affiliates.
              You are welcome to opt not to receive such promotional e-mails from the Product or such affiliates&apos;
              services at any time.
            </p>



            <p>The name of our text messaging program is the Concierge SMS alert program. By providing your mobile phone
              number and opting in, you consent to receive text messages from the Concierge SMS alert program, with
              updates on your connections and other information transactional in nature related to your participation
              in our agent network. You agree to be sent text messages by an automatic telephone dialing system. You
              understand that message and data rates may apply. Message frequency varies. Carriers are not liable for
              delayed or undelivered messages. You can reply STOP to opt out and reply HELP for help or further assistance.
              You may also call customer support for assistance at <a href="tel:18332000101">1-833-200-0101</a>.
              Text messages with connection information are considered transactional. Information obtained from the
              Concierge SMS alert program will not be shared with third parties.</p>

            <p>Please review our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer"> Privacy Policy</a> for
              more information regarding our email and other data collection practices and safeguards, and how to opt not to receive such emails. Your use of the Product signifies
              your acknowledgment of, and agreement with, our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
              We adhere to strong principles of privacy. You agree that we may access and use your user-contributed content in accordance with these
              Terms or our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer"> Privacy Policy</a> and we agree that we will only disclose your user-contributed content
              in accordance with these Terms and our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer"> Privacy Policy</a>. </p>

            <p><b><span className="TermsAndConditions__ordered-list">6.</span>Limitations on Communications and Use of Other Users' Information; No Spam.</b></p>

            <p>You agree that, with respect to other users' personal information that you obtain directly or
              indirectly from or through the Product or through any Product-related communication, transaction
              or software, we have granted to you a license to use such information only for: (i) Product-related
              communications that are not unsolicited commercial messages, (ii) using services offered through
              the Product, and (iii) inquiring about a transaction between you and the other user related to the
              purpose of the Product. Any other purpose will require express permission from the user.  You may
              not use any such information for any unlawful purpose or with any unlawful intent. </p>

            <p>We do not tolerate spam or unsolicited commercial electronic communications of any kind. Therefore,
              without limiting the foregoing, you are not licensed to add a Product user, even a user who has
              used your services, to your mailing list (email or physical mail) without the user's express
              consent. You may not use any tool or service on the Product to send spam or unsolicited commercial
              electronic communications of any kind or in any other way that would violate these Terms.  </p>

            <p>You agree that, with respect to any texting or calling features in the Product, you may be sending
              texts and/or making calls to the wireless phones of consumers, customers, and/or others. It is your
              responsibility to be sure that you have all necessary consents and otherwise comply with all laws and
              regulations that apply to such texts or phone calls. You should only use this text feature to provide
              requested real estate services. Texts and calling through this feature may be monitored and used to improve the Product.</p>

            <p>Additionally, to help manage both your compliance obligations and your customer relationships, any texting
              requests or instructions (e.g., requests to stop sending texts) a person sends you, either through the
              Product or through any other texting medium (e.g., your smartphone), you should treat as applying immediately
              to both your use of the Product feature and to any other texting medium (and potentially other electronic means)
              you use when communicating with that same person. You are responsible for monitoring any such texting requests
              or instructions available through this system.</p>

            <p>Information about certain U.S. laws and regulations that may be relevant:<br />
              Federal Telephone Consumer Protection Act (47 U.S.C. § 227)<br />
              Certain FCC regulations relating to the federal Telephone Consumer Protection Act<br />
              FCC (Federal Communications Commission) webpage for Telemarketing and Robocalls<br />
              FCC (Federal Communications Commission)<br />
              FTC (Federal Trade Commission)<br />
              *Note that other state and federal law may apply<br /></p>

            <p>
              Notwithstanding any other language herein, unless otherwise mutually agreed in writing: (1) it is your
              sole responsibility to ensure that you have obtained all necessary consents under any applicable laws
              or regulations that apply to texts, phone calls, or other forms of communication, use of automated
              technologies or artificial or prerecorded voice or artificial intelligence technologies and (2) we do
              not represent or warrant that the consumer information we provide you with as part of any product or
              otherwise will comply with consent requirements under the TCPA or other applicable laws or regulations
              governing communications. You represent and warrant that any communications you engage in with consumer
              information obtained from us will be compliant with all applicable laws and regulations. We are in no
              way responsible for any noncompliant communications by anyone to whom we provide a consumer’s contact information.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">7.</span>Service Fees.</b></p>

            <p>
              We charge a service fee for which both you and the brokerage that accepted a referral from
              MSI are responsible for. You agree that, should you accept a referral from MSI and
              subsequently close a transaction with such referral, you are required to pay the associated
              service fee even if you were to separate from the brokerage. Refer to the Agent Referral
              Agreement for more information. You understand and acknowledge that we do not run criminal
              background checks on referrals. We do not pre-screen referrals in any way for criminal
              history and encourage you to conduct your business and prospecting activities in a safe manner.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">8.</span>Unsolicited Ideas and Feedback.</b></p>

            <p>
              From time to time, users submit to us ideas or suggestions pertaining to our business, such as
              ideas for new or improved products or technologies, webProduct or tool enhancements, processes,
              materials, marketing plans or new product names.  We are under no obligation to review or
              consider them. If you choose to submit any ideas, original creative artwork, suggestions or
              other works ("submissions") in any form to us, then regardless of what you say, write or
              provide to us in connection with your submissions, the following terms shall apply. The sole
              purpose of this policy is to avoid potential misunderstandings or disputes in the event that
              any part of our business, such as our products, webProducts, technologies or marketing strategies,
              seems similar to any of your submissions. If you provide any submissions to us, you agree
              that: (i) your submission and its contents will automatically become the property of MSI,
              without any compensation to you; (ii) MSI may use or redistribute any such submission and
              its contents for any purpose and in any way; (iii) there is no obligation for MSI to review
              any submission; and (iv) there is no obligation to keep any submission confidential.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">9.</span>Software Available in the Product.</b></p>

            <p>
              The Product is controlled and operated by MSI or an affiliate of MSI in the United
              States.  Software available in the Product (the "Software") is subject to United States
              export controls.  No Software available in the Product or software available may be downloaded
              or otherwise exported or re-exported (i) into (or to a resident of) Cuba, Iraq, Libya, North
              Korea, Iran, Syria or any other country to which the United States has embargoed goods,
              or (ii) anyone on the United States Treasury Department's list of Specially Designated Nationals
              or the United States Commerce Department's Table of Deny Orders.  By using the Product,
              you represent and warrant that you are not located in, under the control of, or a national or
              resident of any such country or on any such list.
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">10.</span>Links to Third-Party Products and WebProducts.</b></p>

            <p>This Product may contain links and pointers to other Internet webProducts, products
              resources and sponsors. Links to and from the Product to other third-party Products,
              maintained by third parties, do not constitute an endorsement by us of any third parties,
              the third-party products or the contents thereof.</p>


            <p><b><span className="TermsAndConditions__ordered-list">11.</span>Limitation of Liability.</b></p>

            <p>
              <strong>
                IN NO EVENT WILL MSI, OR ITS SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, CONSULTANTS,
                AGENTS AND/OR EMPLOYEES (COLLECTIVELY, THE &quot;MSI GROUP&quot;), OR ANY THIRD-PARTY PROVIDER OF
                A SERVICE OR TOOL OFFERED ON ANY PRODUCT OF A MEMBER OF THE MSI GROUP (EACH A "THIRD-PARTY
                PROVIDER"), BE LIABLE FOR ANY LOST PROFITS OR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL,
                OR PUNITIVE DAMAGES ARISING OUT OF, BASED ON, OR RESULTING FROM (A) OUR PRODUCT, (B) THESE
                TERMS, (C) ANY BREACH OF THESE TERMS BY YOU OR A THIRD PARTY, OR (D) USE OF THE PRODUCT,
                TOOLS OR SERVICES WE PROVIDE, OR ANY THIRD PARTY PROVIDER PROVIDES, RELATED TO THE BUSINESS
                WE OPERATE ON THE PRODUCT, BY YOU OR ANY THIRD PARTY. THESE LIMITATIONS AND EXCLUSIONS APPLY
                WITHOUT REGARD TO WHETHER THE DAMAGES ARISE FROM (1) BREACH OF CONTRACT, (2) BREACH OF
                WARRANTY, (3) STRICT LIABILITY, (4) TORT, (5) NEGLIGENCE, OR (6) ANY OTHER CAUSE OF ACTION,
                TO THE MAXIMUM EXTENT SUCH EXCLUSION AND LIMITATIONS ARE NOT PROHIBITED BY APPLICABLE LAW.
              </strong>
            </p>

            <p>
              <strong>
                IF YOU ARE DISSATISFIED WITH THE PRODUCT, YOU DO NOT AGREE WITH ANY PART OF THE TERMS,
                OR HAVE ANY OTHER DISPUTE OR CLAIM WITH OR AGAINST US, ANY THIRD PARTY PROVIDER OR ANY
                USER OF THE PRODUCT WITH RESPECT TO THESE TERMS OR THE PRODUCT, THEN YOUR SOLE AND EXCLUSIVE
                REMEDY AGAINST US IS TO DISCONTINUE USING THE PRODUCT. IN ALL EVENTS, OUR LIABILITY, AND
                THE LIABILITY OF ANY MEMBER OF THE MSI GROUP, TO YOU OR ANY THIRD PARTY IN ANY
                CIRCUMSTANCE ARISING OUT OF OR IN CONNECTION WITH THE PRODUCT IS LIMITED TO THE GREATER OF
                (A) THE AMOUNT OF FEES YOU PAY TO US IN THE TWELVE MONTHS PRIOR TO THE ACTION GIVING RISE
                TO LIABILITY OR (B) $100.00 IN THE AGGREGATE FOR ALL CLAIMS.
              </strong>
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">12.</span>Disclaimers.</b></p>

            <p><b>THE PRODUCT, INCLUDING ALL CONTENT, SOFTWARE, FUNCTIONS, MATERIALS AND INFORMATION MADE
              AVAILABLE ON OR ACCESSED THROUGH THE PRODUCT, IS PROVIDED "AS IS." TO THE FULLEST EXTENT
              PERMISSIBLE BY LAW, WE MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND WHATSOEVER FOR
              THE CONTENT ON THE PRODUCT OR THE MATERIALS, INFORMATION AND FUNCTIONS MADE ACCESSIBLE BY
              THE SOFTWARE USED ON OR ACCESSED THROUGH THE PRODUCT, FOR ANY PRODUCTS OR SERVICES OR
              HYPERTEXT LINKS TO THIRD PARTIES OR FOR ANY BREACH OF SECURITY ASSOCIATED WITH THE
              TRANSMISSION OF SENSITIVE INFORMATION THROUGH THE PRODUCT OR ANY LINKED PRODUCT, EVEN IF
              WE BECOME AWARE OF ANY SUCH BREACHES. FURTHER, WE EXPRESSLY DISCLAIM ANY EXPRESS OR IMPLIED
              WARRANTIES, INCLUDING, WITHOUT LIMITATION, NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR
              A PARTICULAR PURPOSE OR ACCURACY. WE DO NOT WARRANT THAT THE FUNCTIONS CONTAINED ON THE
              PRODUCT OR ANY MATERIALS OR CONTENT CONTAINED THEREIN WILL BE UNINTERRUPTED OR ERROR
              FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE PRODUCT OR THE SERVER THAT MAKES IT
              AVAILABLE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.   YOU ACKNOWLEDGE AND AGREE
              THAT ANY TRANSMISSION TO AND FROM THIS PRODUCT IS NOT CONFIDENTIAL AND YOUR COMMUNICATIONS
              OR USER-CONTRIBUTED CONTENT MAY BE READ OR INTERCEPTED BY OTHERS. YOU FURTHER ACKNOWLEDGE
              AND AGREE THAT BY SUBMITTING COMMUNICATIONS OR USER-CONTRIBUTED CONTENT TO US AND BY POSTING
              INFORMATION ON THE PRODUCT, INCLUDING PROPERTY LISTINGS, NO CONFIDENTIAL, FIDUCIARY,
              CONTRACTUALLY IMPLIED OR OTHER RELATIONSHIP IS CREATED BETWEEN YOU AND US OTHER THAN
              PURSUANT TO THESE TERMS.</b></p>

            <p><b>YOU ACKNOWLEDGE AND AGREE THAT YOU WILL NOT HOLD OR SEEK TO HOLD US OR ANY THIRD
              PARTY PROVIDER RESPONSIBLE FOR THE CONTENT PROVIDED BY ANY USER, INCLUDING,
              WITHOUT LIMITATION, ANY TRANSLATION THEREOF, AND YOU FURTHER ACKNOWLEDGE AND
              AGREE THAT WE ARE NOT A PARTY TO ANY REAL ESTATE TRANSACTION OR OTHER
              TRANSACTION BETWEEN USERS OF THE PRODUCT.</b></p>

            <p><b><span className="TermsAndConditions__ordered-list">13.</span>Release; Indemnification.</b></p>

            <p>
              <strong>
                IN THE EVENT THAT YOU HAVE A DISPUTE WITH ONE OR MORE OTHER USERS OF THE PRODUCT
                (INCLUDING, WITHOUT LIMITATION, ANY DISPUTE BETWEEN USERS REGARDING ANY TRANSACTION OR
                USER-CONTRIBUTED CONTENT) OR ANY THIRD PARTY PROVIDER OR ANY THIRD PARTY WEBPRODUCT
                THAT MAY BE LINKED TO OR FROM OR OTHERWISE INTERACT WITH THE PRODUCT, YOU HEREBY AGREE
                TO RELEASE, REMISE AND FOREVER DISCHARGE EACH MEMBER OF THE MSI GROUP, EACH OF
                THEIR RESPECTIVE AGENTS, DIRECTORS, OFFICERS, EMPLOYEES, AND ALL OTHER RELATED PERSONS
                OR ENTITIES FROM ANY AND ALL MANNER OF RIGHTS, CLAIMS, COMPLAINTS, DEMANDS, CAUSES OF
                ACTION, PROCEEDINGS, LIABILITIES, OBLIGATIONS, LEGAL FEES, COSTS, AND DISBURSEMENTS OF
                ANY NATURE WHATSOEVER, WHETHER KNOWN OR UNKNOWN, WHICH NOW OR HEREAFTER ARISE FROM,
                RELATE TO, OR ARE CONNECTED WITH SUCH DISPUTE AND/OR YOUR USE OF THE PRODUCT.
              </strong>
            </p>

            <p><b>IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE SECTION 1542, WHICH
              SAYS: "A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW
              OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH, IF
              KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR."</b></p>

            <p>
              <strong>
                YOU HEREBY AGREE TO INDEMNIFY, DEFEND AND HOLD EACH MEMBER OF THE MSI GROUP
                (COLLECTIVELY, THE "INDEMNIFIED PARTIES") HARMLESS FROM AND AGAINST ANY AND ALL LIABILITY
                AND COSTS INCURRED BY THE INDEMNIFIED PARTIES IN CONNECTION WITH ANY CLAIM ARISING OUT OF YOUR
                USE OF THE PRODUCT OR OTHERWISE RELATING TO THE BUSINESS WE CONDUCT ON THE PRODUCT (INCLUDING,
                WITHOUT LIMITATION, ANY POTENTIAL OR ACTUAL COMMUNICATION, TRANSACTION OR DISPUTE BETWEEN YOU
                AND ANY OTHER USER OR THIRD PARTY), ANY CONTENT POSTED BY YOU OR ON YOUR BEHALF OR POSTED BY
                OTHER USERS OF YOUR ACCOUNT TO THE PRODUCT, ANY USE OF ANY TOOL OR SERVICE PROVIDED BY A
                THIRD PARTY PROVIDER, ANY USE OF A TOOL OR SERVICE OFFERED BY US THAT INTERACTS WITH A THIRD
                PARTY WEBPRODUCT, OR ANY BREACH BY YOU OF THESE TERMS OR THE REPRESENTATIONS, WARRANTIES AND
                COVENANTS MADE BY YOU HEREIN, INCLUDING WITHOUT LIMITATION, ATTORNEYS' FEES AND COSTS. YOU
                SHALL COOPERATE AS FULLY AS REASONABLY REQUIRED IN THE DEFENSE OF ANY CLAIM.
              </strong>
            </p>

            <p><b>WE RESERVE THE RIGHT, AT OUR OWN EXPENSE, TO ASSUME THE EXCLUSIVE DEFENSE AND CONTROL OF
              ANY MATTER OTHERWISE SUBJECT TO INDEMNIFICATION BY YOU AND YOU SHALL NOT IN ANY EVENT
              SETTLE ANY MATTER WITHOUT OUR WRITTEN CONSENT</b>.</p>

            <p><b><span className="TermsAndConditions__ordered-list">14.</span>Disputes; Arbitration.</b></p>

            <p>
              MSI&apos;s right to amend these Terms, in whole or in part, at any time as set forth below does not
              apply to this &quot;Disputes; Arbitration&quot; section. The version of this  &quot;Disputes; Arbitration&quot;
              section in effect on the date you last accepted the Terms by interacting with the platform or
              realtor.com controls. MSI is committed to customer satisfaction, so if
              you have a problem or dispute, we will try to resolve your concerns. But if we are
              unsuccessful, you may pursue claims as explained in this section. You agree to give
              us an opportunity to resolve any disputes or claims relating in any way to the Product,
              any dealings with our customer experience agents, any services or products provided,
              any representations made by us, or our <a href={this.state.privacyPolicyLink} target="_blank" rel="noopener noreferrer">Privacy Policy</a> (&quot;Claims&quot;)
              by contacting us. If we are not able to resolve your Claims within 60 days,
              you may seek relief through arbitration or in small claims court, as set forth below.
            </p>

            <p>
              <strong>
                Any and all Claims will be resolved by binding arbitration, rather than in court,
                except you may assert Claims on an individual basis in small claims court if they
                qualify. This includes any Claims you assert against us, our subsidiaries, users
                or any companies offering products or services through us (which are beneficiaries
                of this arbitration agreement). This also includes any Claims that arose before
                you accepted these Terms, regardless of whether prior versions of the Terms
                required arbitration.
              </strong>
            </p>

            <p>
              <strong>
                There is no judge or jury in arbitration, and court review of an arbitration
                award is limited. However, an arbitrator can award on an individual basis
                the same damages and relief as a court (including statutory damages, attorneys'
                fees and costs), and must follow and enforce these Terms as a court would.
              </strong>
            </p>

            <p>
              <strong>
                Arbitrations will be conducted by the American Arbitration Association (AAA) under its rules,
                including the AAA Arbitration Consumer Rules (together, the "AAA Rules").
                Payment of all filing, administration and arbitrator fees will be governed by the AAA&apos;s
                rules, except as provided in this section. If your total Claims seek less than $10,000,
                we will reimburse you for filing fees you pay to the AAA and will pay arbitrator's fees.
                You may choose to have an arbitration conducted by telephone, based on written submissions,
                or in person in the state where you live or at another mutually agreed upon location.
              </strong>
            </p>

            <p>
              <strong>
                By agreeing to arbitration under the AAA Rules, the parties agree, among other things, that
                the arbitrator, and not any federal, state, or local court or agency, shall have the
                exclusive power to rule on any objections with respect to the existence, scope, or
                validity of the arbitration agreement or to the arbitrability of any claim or counterclaim
              </strong>
            </p>

            <p>
              <strong>
                To begin an arbitration proceeding, you must send a letter requesting arbitration and describing
                your Claims to &quot;MSI Legal,&quot; at Move Sales, Inc., 901 East 6th St., Suite 500, Austin, TX 78702.
                If we request arbitration against you, we will give you notice at the email address or street
                address you have provided. The AAA&apos;s rules and filing instructions are available at www.adr.org
                or by calling 1-800-778-7879.
              </strong>
            </p>

            <p>
              <strong>
                Any and all proceedings to resolve Claims will be conducted only on an individual
                basis and not in a class, consolidated or representative action. If for any reason
                a Claim proceeds in court rather than in arbitration we each waive any right to a
                jury trial. The Federal Arbitration Act and federal arbitration law apply to these
                Terms. An arbitration decision may be confirmed by any court with competent jurisdiction.
              </strong>
            </p>

            <p><b><span className="TermsAndConditions__ordered-list">15.</span>GENERAL</b></p>

            <p>To Contact Us for any reason, users can visit www.MSI.com.</p>

            <p>These Terms are governed by the Federal Arbitration Act, 9 U.S.C. § 1 et seq. ("FAA"),
              AAA Rules, federal arbitration law, and for U.S. residents, the laws of the state in
              which you reside (as determined by the billing address you have provided us), without
              regard to conflict of laws principles. It is the intent of the parties that the FAA and
              AAA Rules shall preempt all state laws to the fullest extent permitted by law. </p>

            <p>
              Our relationship is that of independent contractors, and no agency, partnership, joint venture,
              employee-employer or franchiser-franchisee relations is intended or created by these Terms or
              your use of the Product. Except as explicitly stated otherwise, any notices to us shall be given
              by postal mail to: realtor.com,
              Attn: Legal Department, 901 East 6th St., Suite 500, Austin, TX 78702.
            </p>

            <p>When we need to send you notice, it will be sent to the email address you provide in
              the Product during the registration process or as later updated in your account
              (if applicable). Notice shall be deemed given upon receipt or 24 hours after an
              email is sent, unless the sending party is notified that the email address is
              invalid. Alternatively, we may give you notice by certified mail, postage prepaid
              and return receipt requested, to any physical address provided to us during the
              registration process or as later updated in your account (if applicable). Notice shall
              be deemed given three days after the date of mailing to a physical address and one day
              after mailing to an electronic address.</p>

            <p>We may change, suspend or discontinue any aspect of the Product at any time, including
              the availability of any Product features, database or content. We may also impose limits
              on certain features or services or restrict your access to parts or the entire Product
              without notice or liability.  This version of the Terms became effective on the date
              set forth above and this version amends the version effective before such date.  We
              reserve the right, in our sole discretion, to amend these Terms, in whole or in part,
              at any time.  Notification of any amendment will be posted on the Product by the
              indication of the last amendment date at the top of these Terms and will be effective
              immediately. When users renew subscriptions, the terms in effect at the time of renewal
              will govern, provided that such terms may change as described above.</p>

            <p>We also reserve the right, in our sole discretion and from time to time, to offer
              programs, products or services with unique terms and conditions that are separate
              from and may supersede or supplement in certain respects these Terms.  In such cases,
              your use of the Product with respect to such special program is governed by these
              Terms together with the terms and conditions of such program, product or service.
              We reserve the right, but assume no obligation, to agree to different or conflicting
              terms and conditions with respect to any user. Any such terms and conditions will
              not be enforceable unless specifically agreed to by us.</p>

            <p>We do not separately file the Terms entered into by each user of the Product.
              Please make a copy of these Terms for your records by printing and/or saving a
              downloaded copy of the Terms on your personal computer. We may immediately
              terminate any user's access to or use of the Product due to such user's breach of
              these Terms or any other unauthorized use of the Product.  However, we do not
              guarantee that we will take action against all breaches of these Terms.  Our failure
              to take immediate action with respect to a breach by you or others does not waive
              our right to act with respect to such breach or any other breach. </p>

            <p>These Terms constitute the entire agreement between us and you with respect to the
              matters set forth herein and supersede any prior agreement between us and you with
              respect to your use of the Product.  Headings in these Terms are for reference only
              and do not limit the scope or extent of such section.  In the event of any conflict
              between these Terms and any other terms and conditions applicable to a product,
              tool or service offered on our Product, the Terms herein shall prevail.  If any
              portion of these Terms is found to be invalid or unenforceable by any court of
              competent jurisdiction, the other provisions of these Terms shall remain in full
              force and effect.  Further, any provision of these Terms held invalid or unenforceable
              only in part or degree will remain in full force and effect to the extent not
              held invalid or unenforceable.</p>

            <p>We may assign these Terms in our sole discretion.  Users must obtain our prior
              written consent to assign these Terms, which may be granted or withheld by us
              in our sole discretion.  </p>
          </div>
        </div>
      </div>
    )
  }
}
